<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">ŠIFARNIK PROIZVODI / SIROVINE</h2>

  <div class="content-block">
    <div class="customTable">
      <dx-data-grid
        class="my-40"
        [dataSource]="proizvodi"
        [showColumnLines]="true"
        noDataText="{{ noDataMessage }}"
        [wordWrapEnabled]="true"
        keyExpr="ar_id"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowUpdated)="artiklUredi($event)"

        [disabled]="pravaZaTrenutniPogled != 2"
      >
      <!--
        (onRowInserted)="onAddProcess($event)"
        (onRowUpdated)="onProcessUpdate($event)"
        (onRowRemoved)="onProcessRemove($event)"
      -->

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[20, 30, 40]"
          [showInfo]="true"
        >
        </dxo-pager>
      
        <dxo-editing
          mode="popup"
          [allowUpdating]="true"
          [allowAdding]="false"
          [allowDeleting]="false"
        >
          <dxo-popup
            [showTitle]="true"
            [width]="600"
            [height]="'auto'"
            title="Proizvod"
          ></dxo-popup>
          <dxo-form labelLocation="top">
            <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
              <dxi-item dataField="ar_sifra"></dxi-item>
              <dxi-item dataField="ar_naziv"></dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="ar_alarm_dani_rok" [label]="{text: 'Broj dana za alarm'}"></dxi-item>
                <dxi-item dataField="ar_alarm_dani_dobavljivost" [label]="{text: 'Broj dana za dobavljivost'}"></dxi-item>
              </dxi-item>
              <dxi-item
                dataField="aktivan"
                editorType="dxSelectBox"
                [editorOptions]="{ items: ['Neaktivan', 'Aktivan'] }"
              ></dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="ar_datumizmjene"></dxi-item>
                <dxi-item dataField="izmjeno_name"></dxi-item>
              </dxi-item>
            </dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column cellTemplate="aktivan" [width]="60">
          <div *dxTemplate="let data of 'aktivan'">
            <span
              *ngIf="data.data.ar_aktivan === 1"
              class="activeProcess"
            ></span>
            <span
              *ngIf="data.data.ar_aktivan === 0"
              class="inactiveProcess"
            ></span>
          </div>
        </dxi-column>
        <dxi-column dataField="aktivan" caption="" [width]="100" [visible]="false"></dxi-column>
        <dxi-column dataField="ar_sifra" caption="Šifra" [width]="100" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="ar_naziv" caption="Naziv" [width]="500" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="ar_alarm_dani_rok" caption="Br.dana alarm" [width]="180"></dxi-column>
        <dxi-column dataField="ar_alarm_dani_dobavljivost" caption="Br.dana dobavljivost" [width]="180"></dxi-column>
        <dxi-column cellTemplate="cellBarkodovi" [width]="60">
          <div *dxTemplate="let data of 'cellBarkodovi'">
            <dx-button [disabled]="pravaZaTrenutniPogled != 2"
              icon="orderedlist"
              hint="Popis barkodova"
              (onClick)="dohvatiArtikl_barkod(data)">
            </dx-button>
          </div>
        </dxi-column>
        <dxi-column dataField="ar_datumizmjene" caption="Zadnja izmjena" dataType="datetime" [width]="100" [allowEditing]="false" [visible]="false"></dxi-column>
        <dxi-column dataField="izmjeno_name" caption="Zadnji izmjenio" [width]="100" [allowEditing]="false" [visible]="false"></dxi-column>

        <div *dxTemplate="let data of 'odabirVrste'">
          <div class="selectDropdown">
            <dx-select-box
              [disabled]="false"
              [width]="180"
              [height]="34"
              [items]="vrstaArray"
              displayExpr="vrsta_naziv"
              valueExpr="vrsta_vrijednost"
              [value]="vrsta"
              (onValueChanged)="vrstaOdabrana($event)">
            </dx-select-box>
          </div>
        </div>

        <div *dxTemplate="let data of 'odabirStatusa'">
          <div class="selectDropdown2">
            <dx-select-box
              [disabled]="false"
              [width]="180"
              [height]="34"
              [items]="statusArray"
              displayExpr="status_naziv"
              valueExpr="status_vrijednost"
              [value]="aktivan"
              (onValueChanged)="statusOdabran($event)">
            </dx-select-box>
          </div>
        </div>

      </dx-data-grid>
    </div>
  </div>
</div>


<!-- artikl barkodovi-->
<dx-popup
  [title]="naslov"
  [showTitle]="true"
  [width]="700"
  height="auto"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="bkPopup"
  [position]="{ my: 'top', at: 'center top', of: '', offset: '0 200' }">

  <dx-data-grid
    id="tablicaBarkodovi"
    [showColumnLines]="true"
    [dataSource]="barkodovi"
    [wordWrapEnabled]="true"
    keyExpr="bk_id"
    [showBorders]="false">
    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxi-column
      dataField="redni_broj"
      caption="Rb."
      [width]="70">
    </dxi-column>
    <dxi-column
      dataField="bk_kod"
      caption="Barkod"
      alignment="center">
    </dxi-column>
    <dxi-column
      caption="Za narudžbu"
      cellTemplate="zaNarudzbu"
      [width]="100"
      alignment="center">
    </dxi-column>
    <div *dxTemplate="let data of 'zaNarudzbu'">
      <dx-check-box
        displayExpr="sgr_naziv"
        [value]="data.data.bk_zanarudzbu"
        (onValueChanged)="urediBarkod($event, data)">
      </dx-check-box>
    </div>
    <dxi-column
      dataField="bk_ukarton"
      caption="Broj komada u kutiji">
    </dxi-column>
    <dxi-column
      dataField="bk_kartonpaleta"
      caption="Broj kutija na paleti">
    </dxi-column>
  </dx-data-grid>

  <dxi-item style="float: right;">
   <dx-button
      class="btnodustani"
      stylingMode="outlined"
      type="normal"
      text="Odustani"
      (onClick)="bkPopup = false">
    </dx-button>
  </dxi-item>
 
  
</dx-popup>